import { render, staticRenderFns } from "./SectionPhilosophy.vue?vue&type=template&id=c85f5cfe&scoped=true"
import script from "./SectionPhilosophy.vue?vue&type=script&lang=js"
export * from "./SectionPhilosophy.vue?vue&type=script&lang=js"
import style0 from "./SectionPhilosophy.vue?vue&type=style&index=0&id=c85f5cfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6._iyputc2ruckis4av77ubvklewu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85f5cfe",
  null
  
)

export default component.exports